import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { teamNameSelector } from './selectors/team';

export const teamsByNameQueryName = 'queryTeamByName';

/**
 * Provides GraphQL query to fetch available Team Names.
 * If this query has been called previously, the value will be read from the cache instead of in a new network request.
 * @param onError custom error handling.
 * @returns custom hook that provides GraphQL query to fetch Team Names.
 */
const useQueryTeamsByName = (
  teamName: string,
  onError: (e: ApolloError) => void
) => {
  const result = useTypedQuery(
    {
      team: [
        {
          where: { name: { _ilike: teamName } },
        },
        teamNameSelector,
      ],
    },
    {
      apolloOptions: {
        onError,
      },
      operationOptions: {
        operationName: teamsByNameQueryName,
      },
    }
  );

  return result;
};

export default useQueryTeamsByName;
